import React, { useEffect, useState } from 'react';
import { Loader2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Input } from '@/components/ui/input';

const QUICK = ['Not the same person', 'Proxy punch', 'Photo not clear', 'Not at work place'];

export const RejectDialog = ({ punch, onClose, onConfirm }) => {
  const [reason, setReason] = useState('');
  const [busy, setBusy] = useState(false);
  useEffect(() => { setReason(''); }, [punch]);
  const go = async () => { setBusy(true); try { await onConfirm(punch, reason.trim()); } finally { setBusy(false); } };
  return (
    <Dialog open={!!punch} onOpenChange={(o) => !o && !busy && onClose()}>
      <DialogContent data-testid="reject-punch-dialog">
        <DialogHeader>
          <DialogTitle>Reject {punch?.kind === 'in' ? 'Check In' : 'Check Out'} — {punch?.staff_name}</DialogTitle>
          <DialogDescription>The punch won't count; the staff member must punch again.</DialogDescription>
        </DialogHeader>
        <div className="flex flex-wrap gap-2">
          {QUICK.map((q) => (
            <button key={q} type="button" onClick={() => setReason(q)} className={`rounded-full border px-3 py-1 text-sm ${reason === q ? 'bg-red-600 text-white border-red-600' : 'bg-white hover:bg-red-50'}`} data-testid={`reject-quick-${q.toLowerCase().replace(/\s+/g, '-')}`}>{q}</button>
          ))}
        </div>
        <Input value={reason} onChange={(e) => setReason(e.target.value)} placeholder="Reason" data-testid="reject-reason-input" />
        <DialogFooter>
          <Button variant="outline" onClick={onClose} disabled={busy} data-testid="reject-cancel">Cancel</Button>
          <Button onClick={go} disabled={busy || reason.trim().length < 3} className="bg-red-600 hover:bg-red-700" data-testid="reject-confirm">
            {busy && <Loader2 className="w-4 h-4 mr-1 animate-spin" />}Reject
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default RejectDialog;
